import { useMutation } from "react-query";
import { updateFeatureFlags } from "../services/updateFeatureFlags";

function useUpdateFeatureFlags() {
  return useMutation(["update-feature-flags"], updateFeatureFlags);
}

export default useUpdateFeatureFlags;
